import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reminderTitleName',
})
export class ReminderTitleName implements PipeTransform {
  transform(text: any, Forms: any, item: any): string {
    text = text.replace('<template name>', Forms.documentName);
    if (text.includes('[expiration date]')) {
      let datatext = '';
      if (item?.calculateDate?.timeline_finish_date) {
        let dateobj = new Date(item?.calculateDate?.timeline_finish_date);
        datatext = this.formatDateCustom(dateobj);
        text = text.replace('[expiration date]', datatext);
      } else if (item?.timeline_finish_date) {
        datatext = this.formatDateFromString(item?.timeline_finish_date);
        text = text.replace('[expiration date]', datatext);
      } else {
        text = text.replace('before', '');
        text = text.replace('on [expiration date]', '');
        text = text.replace('[expiration date]', '');
      }
    }
    if (text.includes('<trigger date>')) {
      let datatext = '';
      if (item?.calculateDate?.timeline_finish_date) {
        let dateobj = new Date(item?.calculateDate?.timeline_finish_date);
        datatext = this.formatDateCustom(dateobj);
      } else if (item?.timeline_finish_date) {
        datatext = this.formatDateFromString(item?.timeline_finish_date);
      }
      text = text.replace('<trigger date>', datatext);
    }
    if (text.includes('<delay>')) {
      let replace_text = '';
      if (item?.object_config?.config?.findIndex((x) => x.field.toLowerCase().trim() == 'delay') >= 0) {
        replace_text = ' ' + item.object_config.config[item.object_config.config.findIndex((x) => x.field.toLowerCase().trim() == 'delay')].default;
        text = text.replace('<delay>', replace_text);
      } else {
        replace_text = item.delay_from_start_date_period + ' ' + item.delay_from_start_date_period_type + '.';
        text = text.replace('<delay>', replace_text);
      }
    }
    return text;
  }
  formatDateFromString(date: string) {
    const [year, month, day] = date.split('-');
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return `${monthNames[parseInt(month) - 1]} ${day}, ${year}`;
  }
  formatDateCustom(dateObj: any) {
    // Parse the date

    // Array of month names
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    // Extract day, month, and year
    const day = dateObj.getDate();
    const month = months[dateObj.getMonth()];
    const year = dateObj.getFullYear();

    // Return formatted string
    return `${month} ${day}, ${year}`;
  }
}
